import routerOptions0 from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}